import CollapsibleSection from "./CollapsibleSection";
import GlobalChannelSettings from "./GlobalChannelSettings";
import CropPreviewContainer from "./CropPreviewContainer";
import useNavbar from "./useNavbar";
import TuneIcon from '@material-ui/icons/Tune';
import PictureInPictureAltIcon from '@material-ui/icons/PictureInPictureAlt';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';

export default function ImageAnnotationSidebar({
  mode,

  atns,

  temporaryAnnotationProperties,
  imageId,

  notifyAnnotationPropertyChange,

  imgRef,

  imageSetId, 
  labelEditable,
  crop,
  cropListMode,


}){

  const [ selected, navbar ] = useNavbar({
    config:{
      spread:true,
      style:{width:'100%'},
    },
    options:[
      {
        label:<PictureInPictureAltIcon/>,
        _id:"list", 
        style:{flex:1}
      },
      {label:<TuneIcon/>,_id:"adjustments", style:{flex:1}},
    ],
    defaultSelected:"adjustments",
  })

  let content;
  if( selected === "adjustments" ){
    content = (
      <GlobalChannelSettings/>
    )
  }else if( selected === "list" ){
    content = (

      !mode && (
        <CropPreviewContainer {...{
          atns,

            temporaryAnnotationProperties,
            imageId,

            notifyAnnotationPropertyChange,

            imgRef,

            imageSetId, 
            labelEditable:false,
            crop,
            cropListMode:(mode==="insertImage"?"list":null)
        }}/>
      )
    )
  }

  return (

    <div style={{position:'relative',right:0,width:'30%',
      maxWidth:280, minWidth:100, borderLeft: '1px solid #ccc',
      minWidth:200,
      }}>
    <div class="sg-col rel">
      {false && <div class="sg-row h-center" style={{textAlign:'center',
borderBottom:'1px solid #ccc',
        paddingBottom:5,
        }}>
        <div style={{ }} class="sg-row">
          <div class="flex-expand"/>
          {navbar}
        </div>
      </div>}

      <CollapsibleSection {...{
        defaultOpen:true,
        sectionTitle:(
          <div class="sg-row v-center">
            <TuneIcon/>
            &nbsp;
            <div style={{fontSize:16,fontWeight:'bold'}}>Adjustments</div>
          </div>
        ),
        sectionStyle:{
          padding:0,
        }

      }}>

        <GlobalChannelSettings disabled={false}/>
      </CollapsibleSection>

      

      <CropPreviewContainer {...{
          atns,

            temporaryAnnotationProperties,
            imageId,

            notifyAnnotationPropertyChange,

            imgRef,

            imageSetId, 
            labelEditable:false,
            crop,
            cropListMode:(mode==="insertImage"?"list":null)
        }}/>

      {false && content}
      
    </div>

    </div>
  )



}
